/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AuthLoginRequest = {
  /**
   * Optional URL to redirect to after successful authentication
   */
  redirect?: string | undefined;
  /**
   * Optional organization name. When set, the organization is created for a new user during the auth callback.
   */
  orgName?: string | undefined;
  /**
   * Optional partner signup code.
   */
  partnerCode?: string | undefined;
  /**
   * Optional email address. Pre-fills the email field on the identity provider's sign-up screen. Never stored.
   */
  email?: string | undefined;
  /**
   * Opaque, one-time organization support handoff. Never included in OAuth state.
   */
  supportHandoff?: string | undefined;
};

export type AuthLoginResponse = {
  headers: { [k: string]: Array<string> };
};

/** @internal */
export type AuthLoginRequest$Outbound = {
  redirect?: string | undefined;
  org_name?: string | undefined;
  partner_code?: string | undefined;
  email?: string | undefined;
  support_handoff?: string | undefined;
};

/** @internal */
export const AuthLoginRequest$outboundSchema: z.ZodMiniType<
  AuthLoginRequest$Outbound,
  AuthLoginRequest
> = z.pipe(
  z.object({
    redirect: z.optional(z.string()),
    orgName: z.optional(z.string()),
    partnerCode: z.optional(z.string()),
    email: z.optional(z.string()),
    supportHandoff: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      orgName: "org_name",
      partnerCode: "partner_code",
      supportHandoff: "support_handoff",
    });
  }),
);

export function authLoginRequestToJSON(
  authLoginRequest: AuthLoginRequest,
): string {
  return JSON.stringify(
    AuthLoginRequest$outboundSchema.parse(authLoginRequest),
  );
}

/** @internal */
export const AuthLoginResponse$inboundSchema: z.ZodMiniType<
  AuthLoginResponse,
  unknown
> = z.pipe(
  z.object({
    Headers: z._default(z.record(z.string(), z.array(z.string())), {}),
  }),
  z.transform((v) => {
    return remap$(v, {
      "Headers": "headers",
    });
  }),
);

export function authLoginResponseFromJSON(
  jsonString: string,
): SafeParseResult<AuthLoginResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AuthLoginResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AuthLoginResponse' from JSON`,
  );
}
